import AjaxRequest from "../modules/ajax-request";

class NewsletterSubscription {
    static RECAPTCHA_ACTION = "newsletter_subscription";
    static instanceCount = 0;

    constructor(element) {
        this.div = element;
        this.form;
        this.format = "";
        this.formFields;
        this.formFeedback;
        this.loadingElement;
        this.showRecaptcha = false;
        this.recaptchaLoaded = false;
        this.ajaxCallData = {};
        this.recaptchaWidget = `newsletter_subscription_${NewsletterSubscription.instanceCount++}`;

        this.init();
        this.getData();
        this.clearData();
        this.bindEvents();
    }

    init() {
        this.form = this.div.querySelector("form");
        this.loadingElement = this.div.querySelector(".add-load-element");
        this.formFields = this.form.querySelectorAll('[data-id="newsletter-subscription-form-field"]');
        this.formFeedback = this.form.querySelector('[data-id="form-feedback"]');
    }

    getData() {
        const d = this.div.dataset;
        [
            this._id,
            this.format,
            this.ajaxCallData.url,
            this.ajaxCallData.controller,
            this.ajaxCallData.action,
            this.ajaxCallData.method,
            this.ajaxCallData.parameters,
            this.ajaxCallData.payload,
            this.ajaxCallData.signature,
            this.showRecaptcha,
        ] = Object.values(d);

        this.showRecaptcha = this.showRecaptcha === 1 || this.showRecaptcha === "1";
    }

    clearData() {
        Array.from(this.div.attributes)
            .filter(attr => attr.name.startsWith("data-"))
            .forEach(attr => this.div.removeAttribute(attr.name));
    }

    bindEvents() {
        this.div.addEventListener("submit", (event) => {
            if (this.showRecaptcha) {
                this.getRecaptcha3Token(event);
            } else {
                this.submitForm(event);
            }
        });

        this.formFields.forEach(field => {
            field.addEventListener("click", () => {
                if (!this.recaptchaLoaded) {
                    this.recaptchaLoaded = true;
                    document.dispatchEvent(new CustomEvent("reCaptcha_domInjection"));
                }
            });
        });

        document.addEventListener("recaptcha3_token_generated", (event) => {
            event.preventDefault();
            if (event.detail.target === this.recaptchaWidget) {
                this.addRecaptchaToken(event);
                this.submitForm(event);
            }
        });
    }

    getRecaptcha3Token(event) {
        event.preventDefault();
        document.dispatchEvent(new CustomEvent("recaptcha3_generate_token", {
            detail: {
                origin: this.recaptchaWidget,
                action: NewsletterSubscription.RECAPTCHA_ACTION,
            }
        }));
    }

    addRecaptchaToken(event) {
        event.preventDefault();
        const input = this.form.querySelector("#newsletter_subscription_recaptcha3");
        if (input) {
            input.value = event.detail.token;
        }
    }

    submitForm(event) {
        event.preventDefault();

        this.formFeedback.classList.remove("is-success", "is-failure");
        const formData = Object.fromEntries(new FormData(this.form));
        const ajaxRequest = new AjaxRequest({
            elementToAddLoading: this.loadingElement,
            successCallback: (response) => {
                this.form.innerHTML = response.message;
                this.init();
                this.formFeedback.classList.add("is-success");
                this.clearFormFields();
            },
            errorCallback: (response) => {
                this.form.innerHTML = response.responseJSON.message;
                this.init();
                this.formFeedback.classList.add("is-failure");
                this.clearFormFields();
            }
        });

        ajaxRequest.makeCall(this.ajaxCallData.url, {
            controller: this.ajaxCallData.controller,
            action: this.ajaxCallData.action,
            method: this.ajaxCallData.method,
            _parameters: this.ajaxCallData.parameters,
            payload: this.ajaxCallData.payload,
            signature: this.ajaxCallData.signature,
            ...formData,
        });
    }

    clearFormFields() {
        const checkbox = this.form.querySelector("newsletter_subscription_privacy");
        if (checkbox) checkbox.checked = false;
        document.dispatchEvent(new CustomEvent("recaptcha_reset"));
    }
}

export default NewsletterSubscription;